import SharedModal from "./SharedModal";
import "./shared-modal.scss";

export default SharedModal;
